import { render } from "./IndicatorTable.vue?vue&type=template&id=6c091d68&scoped=true&ts=true"
import script from "./IndicatorTable.vue?vue&type=script&lang=ts"
export * from "./IndicatorTable.vue?vue&type=script&lang=ts"

import "./IndicatorTable.vue?vue&type=style&index=0&id=6c091d68&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c091d68"]])

export default __exports__